import React, { useEffect, useState } from 'react'

export default function CourtPhoto({ imageUrl, fallbackUrl, className = '', imageClassName = '' }) {
  const [failed, setFailed] = useState([])
  useEffect(() => setFailed([]), [imageUrl, fallbackUrl])
  const src = [imageUrl, fallbackUrl].find(url => url && /^(https:\/\/|blob:)/i.test(url) && !failed.includes(url))
  return src ? <img src={src} alt="" className={imageClassName} onError={() => setFailed(previous => [...previous, src])} /> :
    <div className={`flex h-full w-full items-center justify-center bg-gradient-to-br from-violet-100 via-slate-50 to-emerald-100 text-slate-400 ${className}`} aria-hidden="true"><i /></div>
}
